import MyAssetsPanel from "./MyAssetsPanel";

export default MyAssetsPanel;
